/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const LetterOFCreditListPage = lazyLoad(
  () => import('./index'),
  module => module.LetterOFCreditListPage,
);
